module.exports = __webpack_public_path__ + "static/media/file-alt-regular-grey.9dad9ba3.jpg";